import { render, staticRenderFns } from "./PropertiesSold.vue?vue&type=template&id=412febd0&scoped=true&"
import script from "./PropertiesSold.vue?vue&type=script&lang=ts&"
export * from "./PropertiesSold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412febd0",
  null
  
)

export default component.exports